<button class="button pull-right add-page-button"><i class="icon-plus"></i> <span data-i18n="editor.addPage"></span></button>
<h4 data-i18n="editor.pageList.title"></h4>
<div class="storm-list-group">
	<div class="list-filter">
		<input type="text" class="form-control" data-i18n="[placeholder]editor.pageList.filter">
	</div>
	<ul class="list-content"></ul>
</div>
